export default __webpack_public_path__ + "static/media/harveys.3c874ba3.png";